import { atomsWithMutation } from 'jotai-tanstack-query';
import { V2 } from '@icecreamsocial/api-resources';
import { campaignAtom } from '../campaign';
import { publicKeyAtom } from '../publicKey';
import type { IDataLayer } from '@icecreamsocial/jssdk/src/shared/types/DataLayer';
import { atom } from 'jotai';

export type ConversionParams = {
	conversionType: IDataLayer['engagement'];
	inviteId: string;
	campaignId: string;
	orderId: string;
	identifier: string;
	name: string;
	revenue: string;
	mobileNumber: string;
	email: string;
	emailConsent: boolean;
	smsConsent: boolean;
	transactionId: string;
	influencerId: string;
};

export const [, trackConversionAtom] = atomsWithMutation((get) => ({
	mutationKey: [
		'conversions',
		'trackConversion',
		get(campaignAtom),
		get(publicKeyAtom),
	],
	mutationFn: async (body: Partial<ConversionParams>) => {
		const {
			data,
		} = await V2.Client.createInfluencerFromClientIntermediaryConversion(body, {
			publicKey: get(publicKeyAtom),
		});

		return data;
	},
}));

export const transactionConversionTrackedAtom = atom(false);